module.exports = __webpack_public_path__ + "img/nautilus.4d1894c1.png";